import React from 'react'
import createReactClass from 'create-react-class'
import ModalWrapper from './modal-wrapper'
import ModalContent from './modal-content'

export default createReactClass({
  onYes () {
    this.props.onConfirm()
  },

  onCancel () {
    this.props.closeModal()
  },

  render () {
    return (
      <ModalWrapper>
        <ModalContent title='Are you sure?' {...this.props}>
          {this.props.error ? <div className='modal-error'>{this.props.error}</div> : ''}
          <p>Deletions can not be reversed.</p>
          <div className='pull-right'>
            <a className='btn' onClick={this.onCancel}>No</a>
            <button className='cs-primary-button' type='submit' onClick={this.onYes}>Yes</button>
          </div>
        </ModalContent>
      </ModalWrapper>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/confirmation-modal-panel.js